export const styles = theme => ({
	root: {
		width: "100vw",
		minHeight: "70px",
		height: "70px"
	},
	root1: {
		borderRadius: 0,
		width: 360,
		maxWidth: 360,
		backgroundColor: theme.palette.background.paper
	},
	root2: {
		width: "100%",
		maxWidth: 360,
		backgroundColor: theme.palette.background.paper
	},
	Toolbar: {
		padding: "0 0"
	},
	AppBarcolor: {
		backgroundColor: "#8252fa",
		position: "fixed",
		minHeight: "70px",
		height: "70px"
	},
	grow: {
		flexGrow: 1
	},
	title: {
		display: "none",
		[theme.breakpoints.up("sm")]: {
			display: "block"
		}
	},
	inline: {
		display: "inline",
		fontSize: "1rem",
		fontWeight: 500
	},
	list: {
		width: 250
	},
	fullList: {
		width: "auto"
	},
	nested: {
		paddingLeft: theme.spacing.unit * 4
	}
})
